export interface IOptions {
    id: string | number
    value: string | number
    image?: string
}

export type SelectLabelsKeyword = keyof typeof getListFromKeyword

export function getIDfromList(key: SelectLabelsKeyword, value: string | number): string | number {
    if (getListFromKeyword[key] !== undefined) {
        return getListFromKeyword[key].find(item => item.value === value).id
    }
    return ''
}

export function getValueFromId(key: SelectLabelsKeyword, id: string | number): string | number {
    if (getListFromKeyword[key] !== undefined) {
        return getListFromKeyword[key].find(item => item.id === id)?.value
    }
    return ''
}

export const getListFromKeyword: {[key: string]: IOptions[]} = {
    exchange: [
        {id: '', value: 'Default'},
        {id: 'binance', value: 'Binance'},
        {id: 'bitmex', value: 'BitMEX'},
        {id: 'bithumb', value: 'Bithumb'},
        {id: 'bybit', value: 'Bybit'},
        {id: 'upbit', value: 'Upbit'},
        {id: 'gate', value: 'Gate'},
        {id: 'okex', value: 'OKX'},
        {id: 'phemex', value: 'PheMEX'},
        {id: 'bingx', value: 'BingX Perpetua'},
        {id: 'bitget', value: 'Bitget'},
        {id: 'mexc', value: 'MEXC'},
        {id: 'woo', value: 'WOO X'},
        {id: 'coinbase', value: 'Coinbase'},
        {id: 'blofin', value: 'BloFin'},
        {id: 'blockfin', value: 'Blockfin'},
        {id: 'coinone', value: 'CoinOne'},
        {id: 'tenbagger', value: 'Tenbagger'},
    ],
    noneDefaultExchange: [
        {id: 'binance', value: 'Binance'},
        {id: 'bitmex', value: 'BitMEX'},
        {id: 'bithumb', value: 'Bithumb'},
        {id: 'bybit', value: 'Bybit'},
        {id: 'upbit', value: 'Upbit'},
        {id: 'gate', value: 'Gate'},
        {id: 'okex', value: 'OKX'},
        {id: 'phemex', value: 'PheMEX'},
        {id: 'bingx', value: 'BingX Perpetua'},
        {id: 'bitget', value: 'Bitget'},
        {id: 'mexc', value: 'MEXC'},
        {id: 'woo', value: 'WOO X'},
        {id: 'coinbase', value: 'Coinbase'},
        {id: 'blofin', value: 'BloFin'},
        {id: 'blockfin', value: 'Blockfin'},
        {id: 'coinone', value: 'CoinOne'},
        {id: 'tenbagger', value: 'Tenbagger'},
    ],
    server_mode: [
        {id: '', value: 'Default'},
        {id: 'production', value: 'Production'},
        {id: 'development', value: 'Development'},
    ],
    sort: [
        {id: 'created_at', value: 'Create At'},
        {id: 'bot.balance', value: 'Balance'},
        {id: 'bot.earning', value: 'Earning'},
        {id: 'bot.profit', value: 'Profit'},
    ],
    status: [
        {id: '', value: 'All'},
        {id: 'created', value: 'Created'},
        {id: 'pending', value: 'Pending'},
        {id: 'processing', value: 'Processing'},
        {id: 'confirmed', value: 'Confirmed'},
        {id: 'canceled', value: 'Canceled'},
        {id: 'failed', value: 'Failed'},
    ],
    visibility: [
        {id: 0, value: 'Private'},
        {id: 1, value: 'Public'},
    ],
    channel: [
        {id: 'ko', value: '한국어'},
        {id: 'en', value: 'English'},
    ],
    copierStatus: [
        {id: 'running', value: 'Running'},
        {id: 'all', value: 'All'},
    ],
    copierSort: [
        {id: 'created_at', value: 'Create At'},
        {id: 'balance', value: 'Balance'},
        {id: 'earning', value: 'Earning'},
        {id: 'profit', value: 'Profit'},
    ],
    graph_limit: [
        {id: 7, value: 'Week'},
        {id: 30, value: 'Month'},
        {id: 60, value: '60 Days'},
        {id: 100, value: '100 Days'},
        {id: 365, value: 'Year'},
        {id: 1000, value: 'All'},
    ],
    copy_data_type: [
        {id: 'daily', value: 'Daily'},
        {id: 'monthly', value: 'Monthly'},
    ],
    intelligence_type: [
        {id: 'daily', value: 'Daily'},
        {id: 'hourly', value: 'Hourly'},
    ],
    campaign_action_type: [
        {id: 'web', value: 'Web'},
        {id: 'post', value: 'Post'},
        {id: 'league', value: 'League'},
        {id: 'deeplink', value: 'DeepLink'},
    ],
    revert_point: [
        {id: 1, value: '의미 없는 게시글 작성'},
        {id: 2, value: '버그'},
        {id: 3, value: '광고 / 스팸'},
        {id: 'others', value: '기타'},
    ],
}
